import { render, staticRenderFns } from "./index.vue?vue&type=template&id=497c0689"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497c0689')) {
      api.createRecord('497c0689', component.options)
    } else {
      api.reload('497c0689', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=497c0689", function () {
      api.rerender('497c0689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distributors/index.vue"
export default component.exports